import { Helmet } from 'react-helmet-async';
import Navbar from './Navbar';
import Footer from './Footer';
import { useCmsContent } from '../lib/useCmsContent';

export default function LegalPageShell({ title, description, children }) {
  const { content } = useCmsContent();
  const site = content.siteSettings?.siteName || 'Dragon Metalworks';
  const fullTitle = `${title} | ${site}`;

  return (
    <>
      <Helmet>
        <title>{fullTitle}</title>
        <meta name="description" content={description} />
      </Helmet>
      <Navbar siteName={content.siteSettings.siteName} />
      <main className="legal-page">
        <div className="container">
          <article className="legal-page-inner">{children}</article>
        </div>
      </main>
      <Footer siteSettings={content.siteSettings} footer={content.footer} />
    </>
  );
}
